import { render, staticRenderFns } from "./CoreBatchRunDetail.vue?vue&type=template&id=65d67a44&scoped=true"
import script from "./CoreBatchRunDetail.vue?vue&type=script&lang=js"
export * from "./CoreBatchRunDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65d67a44",
  null
  
)

export default component.exports